import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { authSlice } from './authSlice';
import { packingReducer } from './packing';
import { putawayReducer } from './putaway';
var store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        packing: packingReducer,
        putaway: putawayReducer
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    })
});
export default store;
